
import VideoSquare from "../../../assets/duotone/VideoSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function VideoSquareIcon({ className, dataTestid = "VideoSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <VideoSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
